var AppConfig = module.exports;
AppConfig.sso = true;
AppConfig.returnUrl = window.origin === 'http://localhost:3000' ? 'https://migema.oosa.life' : window.origin;
AppConfig.baseUrl = () => {
  switch (window.origin) {
    case "http://localhost:3000":
    case "http://172.20.10.3:3000":
    case "https://migema.oosa.life":
      return "https://dev-sso.oosa.life/api";
    case "https://dev.oosa.life":
      return "https://dev-sso.oosa.life/api";
    case "https://app-staging.oosa.life":
      return "https://sso-staging.oosa.life/api";
    case "https://app.oosa.life":
      return "https://sso.oosa.life/api";
  }
}

AppConfig.serverUrl = () => {
  switch (window.origin) {
    case "http://localhost:3000":
    case "http://172.20.10.3:3000":
      return "https://dev.oosa.life/api/";
    case "https://migema.oosa.life":
    case "https://dev.oosa.life":
      return "https://dev-auth.oosa.life/api/";
    case "https://app-staging.oosa.life":
      return "https://app-staging.oosa.life/api/";
    case "https://app.oosa.life":
      return "https://app.oosa.life/api/";
  }
}

AppConfig.registerUrl = () => {
  switch (window.origin) {
    case "http://localhost:3000":
    case "http://172.20.10.3:3000":
    case "https://migema.oosa.life":
    case "https://dev.oosa.life":
      return `https://dev-auth.oosa.life/api/sso/register?return_to=${AppConfig.returnUrl}`;
    case "https://app-staging.oosa.life":
      return `https://app-staging.oosa.life/api/sso/register?return_to=${AppConfig.returnUrl}`;
    case "https://app.oosa.life":
      return `https://app.oosa.life/api/sso/register?return_to=${AppConfig.returnUrl}`;
  }
}

AppConfig.limitPocketList = 10;
AppConfig.initialMapStyles = [];
AppConfig.normalMapStyles = [];
AppConfig.announcementTags = ["交通", "住宿", "裝備", "餐飲"];
AppConfig.modeEnum = [
  {
    "id": "66269812fc72a35c9b066f44",
    "label": "露營",
    "label_en": "Camping",
    "type": "campground",
    "keyword": "",
    "img": "./assets/ma1.png",
    "ani": "./tab1/type1.png",
    "cover": "./assets/cover/1.png",
    "type": 1
  },
  {
    "id": "66269850fc72a35c9b066f46",
    "label": "親水",
    "label_en": "water_related",
    "type": "",
    "keyword": "water_related",
    "img": "./assets/ma2.png",
    "ani": "./tab1/type2.png",
    "cover": "./assets/cover/2.png",
    "type": 2
  },
  {
    "id": "662696ebfc72a35c9b066f41",
    "label": "登山",
    "label_en": "Mountain Climbing",
    "type": "",
    "keyword": "mountain climbing",
    "img": "./assets/ma3.png",
    "ani": "./tab1/type3.png",
    "cover": "./assets/cover/3.png",
    "type": 3
  },
  {
    "id": "66269834fc72a35c9b066f45",
    "label": "野餐",
    "label_en": "Picnic",
    "type": "",
    "keyword": "picnic",
    "img": "./assets/ma4.png",
    "ani": "./tab1/type4.png",
    "cover": "./assets/cover/4.png",
    "type": 4
  },
  {
    "id": "662696f2fc72a35c9b066f42",
    "label": "健行",
    "label_en": "HIking Area",
    "type": "",
    "keyword": "hiking",
    "img": "./assets/ma5.png",
    "ani": "./tab1/type5.png",
    "cover": "./assets/cover/5.png",
    "type": 5
  },
  {
    "id": "662697ccfc72a35c9b066f43",
    "label": "生態賞景",
    "label_en": "Ecol. & Landscape",
    "type": "",
    "keyword": "ecotourism",
    "img": "./assets/ma6.png",
    "ani": "./tab1/type6.png",
    "cover": "./assets/cover/6.png",
    "type": 6
  }
]
AppConfig.containerStyle = {
  width: '100%',
  height: '100%',
  background: 'black',
};
AppConfig.taiwanBounds = {
  north: 25.2975,
  south: 20.8962,
  west: 119.3,
  east: 122.1,
};
AppConfig.mapCenter = {
  lat: 23.6,
  lng: 121.029
};

AppConfig.initialMapStylesMapSearch = [
  {
    "featureType": "landscape",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "road",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
];


AppConfig.areaList = [
  { type: "big", id: 1, name: "玉山", lat: 23.47, lng: 120.957222 },
  { type: "big", id: 2, name: "玉山西峰", lat: 23.472426, lng: 120.934205 },
  { type: "big", id: 3, name: "玉山前峰", lat: 23.4756, lng: 120.917661 },
  { type: "big", id: 4, name: "雪山", lat: 24.383401, lng: 121.231754 },
  { type: "big", id: 5, name: "雪山東峰", lat: 23.470775, lng: 120.965668 },
  { type: "big", id: 6, name: "向陽山", lat: 23.28425, lng: 120.992472 },
  { type: "big", id: 7, name: "三叉山", lat: 23.2972, lng: 121.0287 },
  { type: "big", id: 8, name: "合歡北峰", lat: 24.181389, lng: 121.281667 },
  { type: "big", id: 9, name: "合歡東峰", lat: 24.135556, lng: 121.281111 },
  { type: "big", id: 10, name: "合歡主峰", lat: 24.142639, lng: 121.271583 },
  { type: "big", id: 11, name: "石門山", lat: 24.1525, lng: 121.284444 },
  { type: "big", id: 12, name: "合歡西峰", lat: 24.1775, lng: 121.244444 },
  { type: "big", id: 13, name: "畢祿山", lat: 24.213583, lng: 121.347194 },
  { type: "big", id: 14, name: "羊頭山", lat: 24.208194, lng: 121.379778 },
  { type: "big", id: 15, name: "奇萊南峰", lat: 24.061222, lng: 121.279806 },
  { type: "big", id: 16, name: "南華山", lat: 24.0393, lng: 121.286 },
  { type: "big", id: 17, name: "塔關山", lat: 23.251944, lng: 120.941389 },
  { type: "big", id: 18, name: "關山嶺山", lat: 23.270833, lng: 120.959444 },
  { type: "big", id: 19, name: "庫哈諾辛山", lat: 23.262778, lng: 120.9 },
  { type: "big", id: 20, name: "志佳陽山", lat: 24.359972, lng: 121.248139 },
  { type: "big", id: 21, name: "北大武山", lat: 22.627056, lng: 120.761389 },
  { type: "big", id: 22, name: "郡大山", lat: 23.577222, lng: 120.9625 },
  { type: "big", id: 23, name: "巒大山", lat: 23.693944, lng: 120.947389 },
  { type: "big", id: 24, name: "奇萊北峰", lat: 24.1178, lng: 121.335 },
  { type: "big", id: 25, name: "奇萊主峰", lat: 24.086, lng: 121.323 },
  { type: "big", id: 26, name: "品田山", lat: 24.4282, lng: 121.2668 },
  { type: "big", id: 27, name: "桃山", lat: 24.432631, lng: 121.3049 },
  { type: "big", id: 28, name: "池有山", lat: 24.431111, lng: 121.28815 },
  { type: "big", id: 29, name: "喀拉業山", lat: 24.45, lng: 121.321111 },
  { type: "big", id: 30, name: "秀姑巒山", lat: 23.496789, lng: 121.05755 },
  { type: "big", id: 31, name: "大水窟山", lat: 23.4738, lng: 121.0386 },
  { type: "big", id: 32, name: "八通關山", lat: 23.49, lng: 121.009722 },
  { type: "big", id: 33, name: "大霸尖山", lat: 24.4577, lng: 121.258 },
  { type: "big", id: 34, name: "小霸尖山", lat: 24.455556, lng: 121.251389 },
  { type: "big", id: 35, name: "伊澤山", lat: 24.47, lng: 121.244167 },
  { type: "big", id: 36, name: "加利山", lat: 24.459444, lng: 121.216111 },
  { type: "big", id: 37, name: "六順山", lat: 23.724444, lng: 121.239444 },
  { type: "big", id: 38, name: "屏風山", lat: 24.149222, lng: 121.343028 },
  { type: "big", id: 39, name: "白姑大山", lat: 24.202222, lng: 121.108889 },
  { type: "big", id: 40, name: "玉山東峰", lat: 23.4708, lng: 120.9657 },
  { type: "big", id: 41, name: "玉山北峰", lat: 23.4874, lng: 120.9597 },
  { type: "big", id: 42, name: "玉山南峰", lat: 23.4466, lng: 120.9599 },
  { type: "big", id: 43, name: "南玉山", lat: 23.432778, lng: 120.924444 },
  { type: "big", id: 44, name: "鹿山", lat: 23.450639, lng: 120.988611 },
  { type: "big", id: 45, name: "東小南山", lat: 23.439, lng: 120.9634 },
  { type: "big", id: 46, name: "大劍山", lat: 24.3409, lng: 121.2005 },
  { type: "big", id: 47, name: "佳陽山", lat: 24.306389, lng: 121.187778 },
  { type: "big", id: 48, name: "劍山", lat: 24.340833, lng: 121.200278 },
  { type: "big", id: 49, name: "南湖大山", lat: 24.361, lng: 121.439278 },
  { type: "big", id: 50, name: "南湖東峰", lat: 24.365556, lng: 121.450833 },
  { type: "big", id: 51, name: "巴巴山", lat: 24.3425, lng: 121.437778 },
  { type: "big", id: 52, name: "南湖北山", lat: 24.383611, lng: 121.437222 },
  { type: "big", id: 53, name: "審馬陣山", lat: 24.380278, lng: 121.4175 },
  { type: "big", id: 54, name: "中央尖山", lat: 24.310222, lng: 121.416278 },
  { type: "big", id: 55, name: "南湖南峰", lat: 24.3478, lng: 121.4346 },
  { type: "big", id: 56, name: "馬比杉山", lat: 24.349, lng: 121.4834 },
  { type: "big", id: 57, name: "關山", lat: 23.227778, lng: 120.911389 },
  { type: "big", id: 58, name: "卑南主山", lat: 23.051111, lng: 120.874167 },
  { type: "big", id: 59, name: "小關山", lat: 23.151667, lng: 120.876111 },
  { type: "big", id: 60, name: "海諾南山", lat: 23.185528, lng: 120.911306 },
  { type: "big", id: 61, name: "雲峰", lat: 23.3537, lng: 120.9758 },
  { type: "big", id: 62, name: "南雙頭山", lat: 23.346667, lng: 121.015417 },
  { type: "big", id: 63, name: "轆轆山", lat: 23.391333, lng: 120.998111 },
  { type: "big", id: 64, name: "尖山", lat: 24.310222, lng: 121.416278 },
  { type: "big", id: 65, name: "塔芬山", lat: 23.405833, lng: 121.026667 },
  { type: "big", id: 66, name: "能高南峰", lat: 23.965278, lng: 121.278056 },
  { type: "big", id: 67, name: "能高山", lat: 23.9923, lng: 121.26 },
  { type: "big", id: 68, name: "白石山", lat: 23.9075, lng: 121.274722 },
  { type: "big", id: 69, name: "安東軍山", lat: 23.872722, lng: 121.266111 },
  { type: "big", id: 70, name: "光頭山", lat: 23.938056, lng: 121.271944 },
  { type: "big", id: 71, name: "新康山", lat: 23.316389, lng: 121.1275 },
  { type: "big", id: 72, name: "布拉克桑山", lat: 23.232778, lng: 121.078611 },
  { type: "big", id: 73, name: "卓社大山", lat: 23.834444, lng: 121.115833 },
  { type: "big", id: 74, name: "干卓萬山", lat: 23.876306, lng: 121.139028 },
  { type: "big", id: 75, name: "牧山", lat: 23.863611, lng: 121.159722 },
  { type: "big", id: 76, name: "大雪山", lat: 24.330833, lng: 121.121389 },
  { type: "big", id: 77, name: "頭鷹山", lat: 24.359444, lng: 121.140556 },
  { type: "big", id: 78, name: "火石山", lat: 24.381944, lng: 121.175 },
  { type: "big", id: 79, name: "中雪山", lat: 24.336389, lng: 121.077778 },
  { type: "big", id: 80, name: "雪山北峰", lat: 24.414739, lng: 121.2404 },
  { type: "big", id: 81, name: "太魯閣大山", lat: 24.0825, lng: 121.419167 },
  { type: "big", id: 82, name: "磐石山", lat: 24.104722, lng: 121.388333 },
  { type: "big", id: 83, name: "帕托魯山", lat: 24.099444, lng: 121.466528 },
  { type: "big", id: 84, name: "立霧主山", lat: 24.124444, lng: 121.445556 },
  { type: "big", id: 85, name: "馬博拉斯山", lat: 23.5203, lng: 121.0672 },
  { type: "big", id: 86, name: "馬利加南山", lat: 23.521583, lng: 121.117167 },
  { type: "big", id: 87, name: "馬西山", lat: 23.484722, lng: 121.173611 },
  { type: "big", id: 88, name: "盆駒山", lat: 23.548389, lng: 121.0325 },
  { type: "big", id: 89, name: "喀西帕南山", lat: 23.470556, lng: 121.187222 },
  { type: "big", id: 90, name: "無明山", lat: 24.255361, lng: 121.384722 },
  { type: "big", id: 91, name: "鈴鳴山", lat: 24.244444, lng: 121.351667 },
  { type: "big", id: 92, name: "閂山", lat: 24.258639, lng: 121.309889 },
  { type: "big", id: 93, name: "甘薯峰", lat: 24.29, lng: 121.389722 },
  { type: "big", id: 94, name: "東郡大山", lat: 23.6267, lng: 121.0921 },
  { type: "big", id: 95, name: "東巒大山", lat: 23.648056, lng: 121.08 },
  { type: "big", id: 96, name: "丹大山", lat: 23.600417, lng: 121.213528 },
  { type: "big", id: 97, name: "無雙山", lat: 23.590944, lng: 121.057306 },
  { type: "big", id: 98, name: "內嶺爾山", lat: 23.581556, lng: 121.196194 },
  { type: "big", id: 99, name: "義西請馬至山", lat: 23.586917, lng: 121.153167 },
  { type: "big", id: 100, name: "萬東山西峰", lat: 23.852111, lng: 121.185528 },
  { type: "big", id: 101, name: "達芬尖山", lat: 23.432694, lng: 121.013111 },
  { type: "small", id: 1, name: "大屯山", lat: 25.17496261, lng: 121.5230842 },
  { type: "small", id: 2, name: "七星山", lat: 25.1707077, lng: 121.5534425 },
  { type: "small", id: 3, name: "大武崙山（砲台山）", lat: 25.1585127, lng: 121.709823 },
  { type: "small", id: 4, name: "槓子寮山", lat: 25.14310568, lng: 121.7757667 },
  { type: "small", id: 5, name: "觀音山", lat: 25.13591861, lng: 121.426767 },
  { type: "small", id: 6, name: "基隆山", lat: 25.11873479, lng: 121.8491975 },
  { type: "small", id: 7, name: "紅淡山", lat: 25.11886228, lng: 121.7520436 },
  { type: "small", id: 8, name: "大崙頭山", lat: 25.10878027, lng: 121.5854768 },
  { type: "small", id: 9, name: "劍潭山", lat: 25.08426338, lng: 121.5294094 },
  { type: "small", id: 10, name: "五分山", lat: 25.0709483, lng: 121.7807532 },
  { type: "small", id: 11, name: "姜子寮山", lat: 25.05325855, lng: 121.7301566 },
  { type: "small", id: 12, name: "汐止大尖山", lat: 25.05118495, lng: 121.668194 },
  { type: "small", id: 13, name: "南港山", lat: 25.02556625, lng: 121.5863199 },
  { type: "small", id: 14, name: "土庫岳（大坪山）", lat: 25.02312477, lng: 121.6355824 },
  { type: "small", id: 15, name: "大棟山", lat: 23.31136127, lng: 120.5227933 },
  { type: "small", id: 16, name: "南勢角山", lat: 24.96927104, lng: 121.4958563 },
  { type: "small", id: 17, name: "二格山（石尖山）", lat: 24.96724497, lng: 121.6197758 },
  { type: "small", id: 18, name: "天上山", lat: 24.94628568, lng: 121.4561945 },
  { type: "small", id: 19, name: "福德坑山（鳶山）", lat: 24.92662249, lng: 121.345243 },
  { type: "small", id: 20, name: "獅仔頭山", lat: 24.90470742, lng: 121.4912819 },
  { type: "small", id: 21, name: "金面山（鳥嘴尖）", lat: 24.86649751, lng: 121.3355756 },
  { type: "small", id: 22, name: "東眼山", lat: 24.82512133, lng: 121.4175738 },
  { type: "small", id: 23, name: "溪洲山", lat: 24.82448104, lng: 121.277382 },
  { type: "small", id: 24, name: "石門山（小竹坑山）", lat: 24.80999015, lng: 121.2295336 },
  { type: "small", id: 25, name: "石牛山", lat: 24.79351066, lng: 121.253428 },
  { type: "small", id: 26, name: "十八尖山", lat: 24.79253266, lng: 120.984727 },
  { type: "small", id: 27, name: "中坑山", lat: 24.76651976, lng: 121.1191013 },
  { type: "small", id: 28, name: "李崠山（李棟山）", lat: 24.69265801, lng: 121.303752 },
  { type: "small", id: 29, name: "獅頭山", lat: 24.64422804, lng: 121.0066064 },
  { type: "small", id: 30, name: "五指山", lat: 24.64131718, lng: 121.0962819 },
  { type: "small", id: 31, name: "鵝公髻山", lat: 24.61005318, lng: 121.0756964 },
  { type: "small", id: 32, name: "向天湖山", lat: 24.56702024, lng: 121.0271471 },
  { type: "small", id: 33, name: "仙山（紅毛館山）", lat: 24.54253812, lng: 120.9530727 },
  { type: "small", id: 34, name: "加里山", lat: 24.51079921, lng: 121.0125499 },
  { type: "small", id: 35, name: "火炎山", lat: 24.37734565, lng: 120.7303103 },
  { type: "small", id: 36, name: "關刀山", lat: 24.37538202, lng: 120.8109392 },
  { type: "small", id: 37, name: "馬那邦山", lat: 24.36724998, lng: 120.9139267 },
  { type: "small", id: 38, name: "鐵砧山", lat: 24.35634554, lng: 120.655252 },
  { type: "small", id: 39, name: "稍來山", lat: 24.23760365, lng: 120.9715695 },
  { type: "small", id: 40, name: "聚興山", lat: 24.22016133, lng: 120.7428704 },
  { type: "small", id: 41, name: "頭嵙山", lat: 24.17937197, lng: 120.8002745 },
  { type: "small", id: 42, name: "南觀音山", lat: 24.17306182, lng: 120.7411047 },
  { type: "small", id: 43, name: "三汀山", lat: 24.13904965, lng: 120.7527148 },
  { type: "small", id: 44, name: "暗影山", lat: 24.1379947, lng: 120.8179708 },
  { type: "small", id: 45, name: "大橫屏山", lat: 24.07493723, lng: 120.8290745 },
  { type: "small", id: 46, name: "阿罩霧山", lat: 24.06123868, lng: 120.7136683 },
  { type: "small", id: 47, name: "九份二山", lat: 23.93458712, lng: 120.8417753 },
  { type: "small", id: 48, name: "橫山", lat: 23.88922409, lng: 120.6317052 },
  { type: "small", id: 49, name: "貓囒山", lat: 23.88140235, lng: 120.908153 },
  { type: "small", id: 50, name: "集集大山", lat: 23.85497815, lng: 120.8382592 },
  { type: "small", id: 51, name: "松柏坑山（松柏嶺）", lat: 23.82004598, lng: 120.6421771 },
  { type: "small", id: 52, name: "後尖山", lat: 23.81403456, lng: 120.8983269 },
  { type: "small", id: 53, name: "鳳凰山", lat: 23.69171016, lng: 120.8062988 },
  { type: "small", id: 54, name: "金柑樹山", lat: 23.64113417, lng: 120.8140383 },
  { type: "small", id: 55, name: "石壁山", lat: 23.60373479, lng: 120.7246659 },
  { type: "small", id: 56, name: "雲嘉大尖山", lat: 23.59004027, lng: 120.6232766 },
  { type: "small", id: 57, name: "梨子腳山（掘尺嶺山）", lat: 23.56721166, lng: 120.608236 },
  { type: "small", id: 58, name: "獨立山", lat: 23.53670781, lng: 120.6079151 },
  { type: "small", id: 59, name: "大塔山", lat: 23.5359091, lng: 120.8077519 },
  { type: "small", id: 60, name: "大凍山", lat: 23.49788569, lng: 120.719883 },
  { type: "small", id: 61, name: "大湖尖山", lat: 23.49127094, lng: 120.6425123 },
  { type: "small", id: 62, name: "紅毛埤山", lat: 23.48002645, lng: 120.4921051 },
  { type: "small", id: 63, name: "大棟山", lat: 23.31136127, lng: 120.5227933 },
  { type: "small", id: 64, name: "崁頭山", lat: 23.26593756, lng: 120.5046292 },
  { type: "small", id: 65, name: "三腳南山", lat: 23.24063485, lng: 120.5925932 },
  { type: "small", id: 66, name: "西阿里關山", lat: 23.18299569, lng: 120.6413244 },
  { type: "small", id: 67, name: "竹子尖山", lat: 23.17589689, lng: 120.5656458 },
  { type: "small", id: 68, name: "藤枝山", lat: 23.07506251, lng: 120.765595 },
  { type: "small", id: 69, name: "白雲山", lat: 23.05586703, lng: 120.6226911 },
  { type: "small", id: 70, name: "刣牛湖山", lat: 23.04853647, lng: 120.5232073 },
  { type: "small", id: 71, name: "鳴海山", lat: 22.95534127, lng: 120.6905 },
  { type: "small", id: 72, name: "旂尾山（旗尾山）", lat: 22.89677876, lng: 120.4968175 },
  { type: "small", id: 73, name: "尾寮山", lat: 22.85709523, lng: 120.6763886 },
  { type: "small", id: 74, name: "大崗山", lat: 22.86030826, lng: 120.3485719 },
  { type: "small", id: 75, name: "觀音山", lat: 22.72719995, lng: 120.3738044 },
  { type: "small", id: 76, name: "笠頂山", lat: 22.65020169, lng: 120.6440568 },
  { type: "small", id: 77, name: "壽山", lat: 22.6420694, lng: 120.2656453 },
  { type: "small", id: 78, name: "棚集山", lat: 22.50807353, lng: 120.6576991 },
  { type: "small", id: 79, name: "女仍山", lat: 22.19531137, lng: 120.7849275 },
  { type: "small", id: 80, name: "里龍山", lat: 22.16388593, lng: 120.7329653 },
  { type: "small", id: 82, name: "灣坑頭山", lat: 24.859205, lng: 121.9105112 },
  { type: "small", id: 83, name: "三角崙山", lat: 24.85022228, lng: 121.7297946 },
  { type: "small", id: 84, name: "鵲子山", lat: 24.50922215, lng: 121.7675976 },
  { type: "small", id: 85, name: "三星山", lat: 24.17743, lng: 121.5640465 },
  { type: "small", id: 86, name: "卡拉寶山", lat: 24.17812407, lng: 121.3994 },
  { type: "small", id: 87, name: "立霧山", lat: 23.9707785, lng: 121.6420068 },
  { type: "small", id: 88, name: "初音山", lat: 23.91908613, lng: 121.5315112 },
  { type: "small", id: 89, name: "鯉魚山", lat: 23.82550428, lng: 121.5207798 },
  { type: "small", id: 90, name: "月眉山", lat: 23.54474958, lng: 121.5521482 },
  { type: "small", id: 91, name: "八里灣山", lat: 23.23255378, lng: 121.4890982 },
  { type: "small", id: 92, name: "萬人山", lat: 22.89512459, lng: 121.3168538 },
  { type: "small", id: 93, name: "都蘭山", lat: 22.64313927, lng: 121.188453 },
  { type: "small", id: 94, name: "太麻里山", lat: 22.43219728, lng: 120.952615 },
  { type: "small", id: 95, name: "加奈美山", lat: 22.32259015, lng: 120.9101657 },
  { type: "small", id: 96, name: "巴塱衛山", lat: 22.05304465, lng: 120.879018 },
  { type: "small", id: 97, name: "紅頭山", lat: 26.15029335, lng: 121.5347067 },
  { type: "small", id: 98, name: "雲台山", lat: 24.4635272, lng: 119.9234533 },
  { type: "small", id: 99, name: "太武山", lat: 24.467039499984963, lng: 118.4176851830141 },
  { type: "small", id: 100, name: "蛇頭山", lat: 23.54957671, lng: 119.5481147 },
  { type: "protect", id: 1, name: "哈盆自然保留區", lat: 24.776091, lng: 121.513704 },
  { type: "protect", id: 2, name: "鴛鴦湖自然保留區", lat: 24.577693, lng: 121.406264 },
  { type: "protect", id: 3, name: "淡水河紅樹林自然保留區", lat: 25.15671, lng: 121.455737 },
  { type: "protect", id: 4, name: "苗栗三義火炎山自然保留區", lat: 24.361937, lng: 120.726777 },
  { type: "protect", id: 5, name: "大武山自然保留區", lat: 22.595374, lng: 120.950333 },
  { type: "protect", id: 6, name: "插天山自然保留區", lat: 24.760555, lng: 121.412277 },
  { type: "protect", id: 7, name: "南澳闊葉樹林自然保留區(神秘湖)", lat: 24.378173, lng: 121.746423 },
  { type: "protect", id: 8, name: "澎湖玄武岩自然保留區", lat: 23.678122, lng: 119.66846 },
  { type: "protect", id: 9, name: "阿里山台灣一葉蘭自然保留區", lat: 23.53732, lng: 120.798251 },
  { type: "protect", id: 10, name: "烏山頂泥火山自然保留區", lat: 22.796024, lng: 120.405964 },
  { type: "protect", id: 11, name: "挖子尾自然保留區", lat: 25.165519, lng: 121.417819 },
  { type: "protect", id: 12, name: "烏石鼻海岸自然保留區", lat: 24.48158, lng: 121.8586 },
  { type: "protect", id: 13, name: "墾丁高位珊瑚礁自然保留區", lat: 21.965256, lng: 120.822261 },
  { type: "protect", id: 14, name: "九九峰自然保留區", lat: 24.005766, lng: 120.775678 },
  { type: "protect", id: 15, name: "旭海觀音鼻自然保留區", lat: 22.19045, lng: 120.878612 },
  { type: "protect", id: 16, name: "北投石自然保留區", lat: 25.136312, lng: 121.507158 },
  { type: "protect", id: 17, name: "龍崎牛埔惡地自然保留區", lat: 22.929544, lng: 120.405076 },
  { type: "protect", id: 18, name: "草嶺地質公園", lat: 23.584984, lng: 120.694597 },
  { type: "protect", id: 19, name: "草漯沙丘地質公園", lat: 25.071491, lng: 121.129359 },
  { type: "protect", id: 20, name: "澎湖海洋地質公園(中心)", lat: 23.566594, lng: 119.578990 },
  { type: "protect", id: 21, name: "利吉惡地地質公園", lat: 22.815484, lng: 121.138353 },
  { type: "protect", id: 22, name: "東部海岸富岡地質公園", lat: 22.794795, lng: 121.197795 },
  { type: "protect", id: 23, name: "野柳地質公園", lat: 25.206385, lng: 121.690473 },
  { type: "protect", id: 24, name: "龍崎牛埔惡地地質公園", lat: 22.918945, lng: 120.412906 },
  { type: "protect", id: 25, name: "澎湖縣貓嶼海鳥保護區", lat: 23.32439, lng: 119.319347 },
  { type: "protect", id: 26, name: "宜蘭縣無尾港水鳥保護區", lat: 24.615289, lng: 121.855944 },
  { type: "protect", id: 27, name: "臺北市野雁保護區", lat: 25.038362, lng: 121.491488 },
  { type: "protect", id: 28, name: "臺南市四草野生動物保護區", lat: 23.029522, lng: 120.137709 },
  { type: "protect", id: 29, name: "澎湖縣望安島綠蠵龜產卵棲地保護區", lat: 23.354939, lng: 119.500912 },
  { type: "protect", id: 30, name: "大肚溪口野生動物保護區", lat: 24.207894, lng: 120.481571 },
  { type: "protect", id: 31, name: "棉花嶼野生動物保護區", lat: 25.484524, lng: 122.1058 },
  { type: "protect", id: 32, name: "花瓶嶼野生動物保護區", lat: 25.424161, lng: 121.946388 },
  { type: "protect", id: 33, name: "蘭陽溪口水鳥保護區", lat: 24.718152, lng: 121.831372 },
  { type: "protect", id: 34, name: "櫻花鉤吻鮭野生動物保護區", lat: 24.354171, lng: 121.312846 },
  { type: "protect", id: 35, name: "臺東縣海端鄉新武呂溪魚類保護區", lat: 23.218332, lng: 121.075489 },
  { type: "protect", id: 36, name: "玉里野生動物保護區", lat: 23.40454, lng: 121.216814 },
  { type: "protect", id: 37, name: "新竹市濱海野生動物保護區", lat: 24.810387, lng: 120.909275 },
  { type: "protect", id: 38, name: "臺南縣曾文溪口北岸黑面琵鷺動物保護區", lat: 23.079182, lng: 120.053098 },
  { type: "protect", id: 39, name: "雙連埤野生動物保護區", lat: 24.750227, lng: 121.640348 },
  { type: "protect", id: 40, name: "臺中市高美野生動物保護區", lat: 24.313272, lng: 120.545185 },
  { type: "protect", id: 41, name: "桃園高榮野生動物保護區", lat: 24.934011, lng: 121.17686 },
  { type: "protect", id: 42, name: "桃園觀新藻礁生態系野生動物保護區", lat: 25.018356, lng: 121.033397 },
  { type: "protect", id: 43, name: "臺中市武陵櫻花鉤吻鮭重要棲息環境", lat: 24.354171, lng: 121.31285 },
  { type: "protect", id: 44, name: "宜蘭縣蘭陽溪口野生動物重要棲息環境", lat: 24.718153, lng: 121.831371 },
  { type: "protect", id: 45, name: "臺北市中興橋永福橋野生動物重要棲息環境", lat: 25.038356, lng: 121.491473 },
  { type: "protect", id: 46, name: "大肚溪口野生動物重要棲息環境", lat: 24.18913, lng: 120.498456 },
  { type: "protect", id: 47, name: "臺東縣海端鄉新武呂溪野生動物重要棲息環境", lat: 22.805246, lng: 121.031574 },
  { type: "protect", id: 48, name: "玉里野生動物重要棲息環境", lat: 23.404539, lng: 121.216815 },
  { type: "protect", id: 49, name: "丹大野生動物重要棲息環境", lat: 23.978037, lng: 121.257856 },
  { type: "protect", id: 50, name: "觀音海岸野生動物重要棲息環境", lat: 24.412279, lng: 121.790727 },
  { type: "protect", id: 51, name: "鹿林山野生動物重要棲息環境", lat: 23.435458, lng: 120.780965 },
  { type: "protect", id: 52, name: "雙鬼湖野生動物重要棲息環境", lat: 22.834796, lng: 121.009499 },
  { type: "protect", id: 53, name: "利嘉野生動物重要棲息環境", lat: 22.805244, lng: 121.031573 },
  { type: "protect", id: 54, name: "水璉野生動物重要棲息環境", lat: 23.814366, lng: 121.573495 },
  { type: "protect", id: 55, name: "臺南市四草野生動物重要棲息環境", lat: 23.029521, lng: 120.137713 },
  { type: "protect", id: 56, name: "桃園高榮野生動物重要棲息環境", lat: 24.93401, lng: 121.17686 },
  { type: "protect", id: 58, name: "雪霸自然保護區", lat: 24.36235, lng: 121.125203 },
  { type: "protect", id: 59, name: "大武臺灣油杉自然保護區", lat: 22.399056, lng: 120.826922 },
  { type: "protect", id: 60, name: "甲仙四德化石自然保護區", lat: 23.089681, lng: 120.582347 },
  { type: "protect", id: 61, name: "十八羅漢山自然保護區", lat: 22.944355, lng: 120.634582 },
];


AppConfig.allCountry = [
  { code: "AF", lat: 34.52813, lng: 69.17233 },
  { code: "AL", lat: 41.3275, lng: 19.81889 },
  { code: "DZ", lat: 36.73225, lng: 3.08746 },
  { code: "AD", lat: 42.50779, lng: 1.52109 },
  { code: "AO", lat: -8.83682, lng: 13.23432 },
  { code: "AG", lat: 17.12741, lng: -61.84677 },
  { code: "AR", lat: -34.60852, lng: -58.37354 },
  { code: "AM", lat: 40.18111, lng: 44.51361 },
  { code: "AU", lat: -35.28346, lng: 149.12807 },
  { code: "AT", lat: 48.20849, lng: 16.37208 },
  { code: "AZ", lat: 40.39528, lng: 49.88222 },
  { code: "BS", lat: 25.03428, lng: -77.39628 },
  { code: "BH", lat: 26.23612, lng: 50.58306 },
  { code: "BD", lat: 23.70992, lng: 90.40706 },
  { code: "BB", lat: 13.10639, lng: -59.61744 },
  { code: "BY", lat: 53.9, lng: 27.56667 },
  { code: "BE", lat: 50.85045, lng: 4.34878 },
  { code: "BZ", lat: 17.49952, lng: -88.19756 },
  { code: "BJ", lat: 6.49686, lng: 2.62878 },
  { code: "BT", lat: 27.47279, lng: 89.63928 },
  { code: "BO", lat: -16.50003, lng: -68.15055 },
  { code: "BA", lat: 43.84864, lng: 18.35644 },
  { code: "BW", lat: -24.65451, lng: 25.90859 },
  { code: "BR", lat: -15.77972, lng: -47.92972 },
  { code: "BN", lat: 4.89035, lng: 114.94217 },
  { code: "BG", lat: 42.69751, lng: 23.32415 },
  { code: "BF", lat: 12.36566, lng: -1.53388 },
  { code: "BI", lat: -3.3822, lng: 29.3644 },
  { code: "CV", lat: 14.9167, lng: -23.5092 },
  { code: "KH", lat: 11.55883, lng: 104.91745 },
  { code: "CM", lat: 3.848, lng: 11.5021 },
  { code: "CA", lat: 45.41117, lng: -75.69812 },
  { code: "CF", lat: 4.36122, lng: 18.55597 },
  { code: "TD", lat: 12.10672, lng: 15.0444 },
  { code: "CL", lat: -33.46912, lng: -70.641 },
  { code: "CN", lat: 39.9075, lng: 116.39723 },
  { code: "CO", lat: 4.60971, lng: -74.08175 },
  { code: "KM", lat: -11.7042, lng: 43.2439 },
  { code: "CG", lat: -4.26336, lng: 15.2429 },
  { code: "CR", lat: 9.93333, lng: -84.08333 },
  { code: "HR", lat: 45.81444, lng: 15.97898 },
  { code: "CU", lat: 23.13302, lng: -82.38304 },
  { code: "CY", lat: 35.17531, lng: 33.3642 },
  { code: "CZ", lat: 50.08804, lng: 14.42076 },
  { code: "DK", lat: 55.67594, lng: 12.56553 },
  { code: "DJ", lat: 11.58901, lng: 43.14503 },
  { code: "DM", lat: 15.30174, lng: -61.38808 },
  { code: "DO", lat: 18.47186, lng: -69.89155 },
  { code: "EC", lat: -0.22985, lng: -78.52495 },
  { code: "EG", lat: 30.06263, lng: 31.24967 },
  { code: "SV", lat: 13.68935, lng: -89.18718 },
  { code: "GQ", lat: 3.7523, lng: 8.7737 },
  { code: "ER", lat: 15.3333, lng: 38.9333 },
  { code: "EE", lat: 59.437, lng: 24.7535 },
  { code: "SZ", lat: -26.3167, lng: 31.1333 },
  { code: "ET", lat: 9.03, lng: 38.74 },
  { code: "FJ", lat: -18.1416, lng: 178.4419 },
  { code: "FI", lat: 60.1692, lng: 24.9402 },
  { code: "FR", lat: 48.85341, lng: 2.3488 },
  { code: "GA", lat: 0.38832, lng: 9.4546 },
  { code: "GM", lat: 13.4549, lng: -16.579 },
  { code: "GE", lat: 41.69411, lng: 44.83368 },
  { code: "DE", lat: 52.52437, lng: 13.41053 },
  { code: "GH", lat: 5.55602, lng: -0.1969 },
  { code: "GR", lat: 37.98376, lng: 23.72784 },
  { code: "GD", lat: 12.0564, lng: -61.7485 },
  { code: "GT", lat: 14.63491, lng: -90.50688 },
  { code: "GN", lat: 9.5092, lng: -13.7122 },
  { code: "GW", lat: 11.859, lng: -15.596 },
  { code: "GY", lat: 6.80448, lng: -58.15527 },
  { code: "HT", lat: 18.53917, lng: -72.33667 },
  { code: "HN", lat: 14.0818, lng: -87.20681 },
  { code: "HU", lat: 47.49791, lng: 19.04023 },
  { code: "IS", lat: 64.13548, lng: -21.89541 },
  { code: "IN", lat: 28.65195, lng: 77.23149 },
  { code: "ID", lat: -6.21462, lng: 106.84513 },
  { code: "IR", lat: 35.69439, lng: 51.42151 },
  { code: "IQ", lat: 33.34058, lng: 44.40088 },
  { code: "IE", lat: 53.33306, lng: -6.24889 },
  { code: "IL", lat: 31.76904, lng: 35.21633 },
  { code: "IT", lat: 41.89474, lng: 12.48591 },
  { code: "JM", lat: 18.0125, lng: -76.79202 },
  { code: "JP", lat: 35.6895, lng: 139.69171 },
  { code: "JO", lat: 31.95522, lng: 35.94503 },
  { code: "KZ", lat: 51.16939, lng: 71.44907 },
  { code: "KE", lat: -1.29207, lng: 36.82195 },
  { code: "KI", lat: 1.329, lng: 172.979 },
  { code: "KP", lat: 39.03385, lng: 125.75432 },
  { code: "KR", lat: 37.566, lng: 126.9784 },
  { code: "XK", lat: 42.66754, lng: 21.16688 },
  { code: "KW", lat: 29.36972, lng: 47.97833 },
  { code: "KG", lat: 42.87, lng: 74.59 },
  { code: "LA", lat: 17.96667, lng: 102.6 },
  { code: "LV", lat: 56.946, lng: 24.105 },
  { code: "LB", lat: 33.89332, lng: 35.50157 },
  { code: "LS", lat: -29.31667, lng: 27.48333 },
  { code: "LR", lat: 6.30054, lng: -10.79672 },
  { code: "LY", lat: 32.87519, lng: 13.18746 },
  { code: "LI", lat: 47.1383, lng: 9.5222 },
  { code: "LT", lat: 54.68916, lng: 25.2798 },
  { code: "LU", lat: 49.61167, lng: 6.13 },
  { code: "MG", lat: -18.9156, lng: 47.5306 },
  { code: "MW", lat: -13.98333, lng: 33.78333 },
  { code: "MY", lat: 3.139, lng: 101.68685 },
  { code: "MV", lat: 4.175, lng: 73.5093 },
  { code: "ML", lat: 12.6392, lng: -8.0029 },
  { code: "MT", lat: 35.89972, lng: 14.51472 },
  { code: "MH", lat: 7.103, lng: 171.3802 },
  { code: "MR", lat: 18.0858, lng: -15.9785 },
  { code: "MU", lat: -20.1625, lng: 57.4977 },
  { code: "MX", lat: 19.4326, lng: -99.1332 },
  { code: "FM", lat: 6.923, lng: 158.185 },
  { code: "MD", lat: 47.0105, lng: 28.8638 },
  { code: "MC", lat: 43.7333, lng: 7.4167 },
  { code: "MN", lat: 47.9203, lng: 106.917 },
  { code: "ME", lat: 42.4411, lng: 19.2636 },
  { code: "MA", lat: 34.0132, lng: -6.8326 },
  { code: "MZ", lat: -25.9667, lng: 32.5833 },
  { code: "MM", lat: 16.8634, lng: 96.1951 },
  { code: "NA", lat: -22.5597, lng: 17.0836 },
  { code: "NR", lat: -0.5228, lng: 166.9315 },
  { code: "NP", lat: 27.7172, lng: 85.324 },
  { code: "NL", lat: 52.3731, lng: 4.8922 },
  { code: "NZ", lat: -41.2865, lng: 174.7762 },
  { code: "NI", lat: 12.1328, lng: -86.2504 },
  { code: "NE", lat: 13.5137, lng: 2.1098 },
  { code: "NG", lat: 9.05785, lng: 7.49508 },
  { code: "MK", lat: 41.9981, lng: 21.4254 },
  { code: "NO", lat: 59.9115, lng: 10.7579 },
  { code: "OM", lat: 23.6159, lng: 58.5922 },
  { code: "PK", lat: 33.6844, lng: 73.0479 },
  { code: "PW", lat: 7.3411, lng: 134.479 },
  { code: "PS", lat: 31.8996, lng: 35.2042 },
  { code: "PA", lat: 8.9833, lng: -79.5167 },
  { code: "PG", lat: -9.478, lng: 147.15 },
  { code: "PY", lat: -25.3, lng: -57.6333 },
  { code: "PE", lat: -12.0464, lng: -77.0428 },
  { code: "PH", lat: 14.5995, lng: 120.9842 },
  { code: "PL", lat: 52.2298, lng: 21.0118 },
  { code: "PT", lat: 38.7167, lng: -9.139 },
  { code: "QA", lat: 25.2867, lng: 51.5333 },
  { code: "RO", lat: 44.4268, lng: 26.1025 },
  { code: "RU", lat: 55.7558, lng: 37.6173 },
  { code: "RW", lat: -1.9579, lng: 30.1127 },
  { code: "KN", lat: 17.3026, lng: -62.7177 },
  { code: "LC", lat: 14.0101, lng: -60.9875 },
  { code: "VC", lat: 13.1553, lng: -61.2232 },
  { code: "WS", lat: -13.8333, lng: -171.7667 },
  { code: "SM", lat: 43.9333, lng: 12.45 },
  { code: "ST", lat: 0.3333, lng: 6.7333 },
  { code: "SA", lat: 24.6333, lng: 46.7167 },
  { code: "SN", lat: 14.6937, lng: -17.4441 },
  { code: "RS", lat: 44.8176, lng: 20.4633 },
  { code: "SC", lat: -4.6167, lng: 55.45 },
  { code: "SL", lat: 8.484, lng: -13.2342 },
  { code: "SG", lat: 1.2897, lng: 103.8501 },
  { code: "SK", lat: 48.1486, lng: 17.1077 },
  { code: "SI", lat: 46.0511, lng: 14.5051 },
  { code: "SB", lat: -9.4319, lng: 159.9552 },
  { code: "SO", lat: 2.0411, lng: 45.3425 },
  { code: "ZA", lat: -25.7461, lng: 28.1881 },
  { code: "SS", lat: 4.85, lng: 31.6 },
  { code: "ES", lat: 40.4165, lng: -3.7026 },
  { code: "LK", lat: 6.9271, lng: 79.8612 },
  { code: "SD", lat: 15.5007, lng: 32.5599 },
  { code: "SR", lat: 5.8661, lng: -55.1668 },
  { code: "SE", lat: 59.3294, lng: 18.0686 },
  { code: "CH", lat: 46.9481, lng: 7.4474 },
  { code: "SY", lat: 33.5131, lng: 36.2919 },
  { code: "TW", lat: 25.0329, lng: 121.5654 },
  { code: "TJ", lat: 38.5365, lng: 68.7792 },
  { code: "TZ", lat: -6.8121, lng: 39.2804 },
  { code: "TH", lat: 13.7563, lng: 100.5018 },
  { code: "TL", lat: -8.5569, lng: 125.5736 },
  { code: "TG", lat: 6.1287, lng: 1.2217 },
  { code: "TO", lat: -21.1394, lng: -175.2014 },
  { code: "TT", lat: 10.6672, lng: -61.5189 },
  { code: "TN", lat: 36.8188, lng: 10.166 },
  { code: "TR", lat: 39.9334, lng: 32.8597 },
  { code: "TM", lat: 37.95, lng: 58.3833 },
  { code: "TV", lat: -8.5167, lng: 179.2167 },
  { code: "UG", lat: 0.3476, lng: 32.5825 },
  { code: "UA", lat: 50.4501, lng: 30.5234 },
  { code: "AE", lat: 24.4667, lng: 54.3667 },
  { code: "GB", lat: 51.5074, lng: -0.1278 },
  { code: "US", lat: 38.89511, lng: -77.03637 },
  { code: "UY", lat: -34.9011, lng: -56.1645 },
  { code: "UZ", lat: 41.2995, lng: 69.2401 },
  { code: "VU", lat: -17.7333, lng: 168.3211 },
  { code: "VE", lat: 10.4925, lng: -66.8792 },
  { code: "VN", lat: 21.0285, lng: 105.8542 },
  { code: "WF", lat: -13.3000, lng: -176.2000 },
  { code: "YE", lat: 15.5527, lng: 48.5164 },
  { code: "ZM", lat: -15.3875, lng: 28.3228 },
  { code: "ZW", lat: -17.8292, lng: 31.0522 }
];
AppConfig.msgPos = [
        { marginTop: "10%", width: "55%", height: "20rem", lineHeight: "1.8rem", col: 6 },
        { marginTop: "16%", width: "55%", height: "20rem", lineHeight: "1.8rem", col: 6 },
        { marginTop: "40%", width: "70%", height: "12rem", lineHeight: "1.4rem", col: 6 },
        { marginTop: "16%", width: "55%", height: "20rem", lineHeight: "1.8rem", col: 6 },
        { marginTop: "16%", width: "65%", height: "20rem", lineHeight: "1.8rem", col: 6 },
        { marginTop: "16%", width: "55%", height: "20rem", lineHeight: "1.8rem", col: 6 },
    ]
AppConfig.InvitePosDetail = (styleIndex, eventVo, findObj) => {
  const posDetails = [
    [
        { type: "text", text: eventVo.events_name, fontSize: 42, x: 450, y: 180, color: "#B34438", maxWidth: 580, fontWeight: 500 },
        { type: "text", text: `${eventVo.events_date.formatYYYYMMDD3()} - ${eventVo.events_date_end.formatYYYYMMDD3()}`, fontSize: 32, x: 450, y: 310, color: "#B34438" },
        { type: "img", x: 323, y: 340, img: findObj.img, width: 240, height: 240 },
        { type: "img", x: 160, y: 672, img: './assets/ui/Location_r.png', width: 50, height: 50 },
        { type: "text", text: `${findObj.label}`, fontSize: 36, x: 450, y: 646, color: "#B34438", fontWeight: 500 },
        { type: "text", text: eventVo.rewildingObj.rewilding_name, maxLength: 25, fontSize: 32, x: 215, y: 710, color: "#B34438", maxWidth: 530, align: "left" },
        { type: "text", text: `Rewilding No.${eventVo.events_invitation_no ?? "501"}`, fontFamily: 'Anaheim', fontWeight: 500, letterSpacing: -4, maxLength: 25, fontSize: 32, x: 450, y: 860, color: "#B34438", maxWidth: 530, align: "center" },
    ],
    [
        { type: "text", text: eventVo.events_name, fontSize: 42, x: 450, y: 220, color: "#B34438", maxWidth: 580, fontWeight: 500 },
        { type: "text", text: `${eventVo.events_date.formatYYYYMMDD3()} - ${eventVo.events_date_end.formatYYYYMMDD3()}`, fontSize: 32, x: 450, y: 330, color: "#B34438" },
        { type: "img", x: 323, y: 360, img: findObj.img, width: 240, height: 240 },
        { type: "img", x: 160, y: 692, img: './assets/ui/Location_r.png', width: 50, height: 50 },
        { type: "text", text: `${findObj.label}`, fontSize: 36, x: 450, y: 666, color: "#B34438", fontWeight: 500 },
        { type: "text", text: eventVo.rewildingObj.rewilding_name, maxLength: 25, fontSize: 32, x: 215, y: 730, color: "#B34438", maxWidth: 530, align: "left" },
        { type: "text", text: `Rewilding No.${eventVo.events_invitation_no ?? "501"}`, fontFamily: 'Anaheim', fontWeight: 500, letterSpacing: -4, maxLength: 25, fontSize: 32, x: 450, y: 860, color: "#B34438", maxWidth: 530, align: "center" },
    ],
    [
        { type: "text", text: eventVo.events_name, fontSize: 42, x: 450, y: 140, color: "#B34438", maxWidth: 580, fontWeight: 500 },
        { type: "text", text: `${eventVo.events_date.formatYYYYMMDD3()} - ${eventVo.events_date_end.formatYYYYMMDD3()}`, fontSize: 32, x: 450, y: 270, color: "#B34438" },
        { type: "img", x: 323, y: 450, img: findObj.img, width: 240, height: 240 },
        { type: "img", x: 160, y: 702, img: './assets/ui/Location_r.png', width: 50, height: 50 },
        { type: "text", text: `${findObj.label}`, fontSize: 36, x: 450, y: 426, color: "#B34438", fontWeight: 500 },
        { type: "text", text: eventVo.rewildingObj.rewilding_name, maxLength: 25, fontSize: 32, x: 215, y: 740, color: "#B34438", maxWidth: 530, align: "left" },
        { type: "text", text: `Rewilding No.${eventVo.events_invitation_no ?? "501"}`, fontFamily: 'Anaheim', fontWeight: 500, letterSpacing: -4, maxLength: 25, fontSize: 32, x: 450, y: 860, color: "#B34438", maxWidth: 530, align: "center" },
    ],
    [
        { type: "text", text: eventVo.events_name, fontSize: 42, x: 450, y: 210, color: "#B34438", maxWidth: 580, fontWeight: 500 },
        { type: "text", text: `${eventVo.events_date.formatYYYYMMDD3()} - ${eventVo.events_date_end.formatYYYYMMDD3()}`, fontSize: 32, x: 450, y: 320, color: "#B34438" },
        { type: "img", x: 323, y: 350, img: findObj.img, width: 240, height: 240 },
        { type: "img", x: 160, y: 672, img: './assets/ui/Location_r.png', width: 50, height: 50 },
        { type: "text", text: `${findObj.label}`, fontSize: 36, x: 450, y: 656, color: "#B34438", fontWeight: 500 },
        { type: "text", text: eventVo.rewildingObj.rewilding_name, maxLength: 25, fontSize: 32, x: 215, y: 710, color: "#B34438", maxWidth: 530, align: "left" },
        { type: "text", text: `Rewilding No.${eventVo.events_invitation_no ?? "501"}`, fontFamily: 'Anaheim', fontWeight: 500, letterSpacing: -4, maxLength: 25, fontSize: 32, x: 450, y: 994, color: "#B34438", maxWidth: 530, align: "center" },
    ],
    [
        { type: "text", text: eventVo.events_name, fontSize: 42, x: 450, y: 210, color: "#B34438", maxWidth: 580, fontWeight: 500 },
        { type: "text", text: `${eventVo.events_date.formatYYYYMMDD3()} - ${eventVo.events_date_end.formatYYYYMMDD3()}．${findObj.label}`, fontSize: 32, x: 450, y: 580, color: "#B34438" },
        { type: "img", x: 323, y: 300, img: findObj.img, width: 240, height: 240 },
        { type: "img", x: 200, y: 612, img: './assets/ui/Location_r.png', width: 50, height: 50 },
        { type: "text", text: eventVo.rewildingObj.rewilding_name, maxLength: 25, fontSize: 32, x: 255, y: 650, color: "#B34438", maxWidth: 530, align: "left" },
        { type: "text", text: `Rewilding No.${eventVo.events_invitation_no ?? "501"}`, fontFamily: 'Anaheim', fontWeight: 500, letterSpacing: -4, maxLength: 25, fontSize: 30, x: 90, y: 1026, color: "#B34438", maxWidth: 530, align: "left" },
    ],
    [
        { type: "text", text: eventVo.events_name, fontSize: 42, x: 450, y: 170, color: "#B34438", maxWidth: 580, fontWeight: 500 },
        { type: "text", text: `${eventVo.events_date.formatYYYYMMDD3()} - ${eventVo.events_date_end.formatYYYYMMDD3()}`, fontSize: 32, x: 450, y: 290, color: "#B34438" },
        { type: "img", x: 323, y: 330, img: findObj.img, width: 240, height: 240 },
        { type: "img", x: 160, y: 692, img: './assets/ui/Location_r.png', width: 50, height: 50 },
        { type: "text", text: `${findObj.label}`, fontSize: 36, x: 450, y: 646, color: "#B34438", fontWeight: 500 },
        { type: "text", text: eventVo.rewildingObj.rewilding_name, maxLength: 25, fontSize: 32, x: 215, y: 730, color: "#B34438", maxWidth: 530, align: "left" },
        { type: "text", text: `Rewilding No.${eventVo.events_invitation_no ?? "501"}`, fontFamily: 'Anaheim', fontWeight: 500, letterSpacing: -4, maxLength: 25, fontSize: 30, x: 90, y: 916, color: "#B34438", maxWidth: 530, align: "left" },
    ],
]
  return posDetails[styleIndex];
}






































































